import { Group, IGroup } from './group';

export class Groups {
	public static parse(data: IGroups): Groups {
		const groups: Groups = new Groups();
		if ((data.value !== undefined) && (data.value.length > 0)) {
			for (const value of data.value) {
				const group: Group = Group.parse(value);
				if (group) {
					groups.value.push(group);
				}
			}
		}
		return groups;
	}
	public value: Group[] = [];

	public get(id: string): Group | null {
		for (const group of this.value) {
			if (group.id === id) {
				return group;
			}
		}
		return null;
	}
}

export interface IGroups {
	value?: IGroup[];
}
